import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/FAQSection.css';
import QuoteModal from './QuoteModal';

const FAQSection = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  const handleContactSupport = () => {
    window.location.href = 'tel:03323240508';
  };

  const faqs = [
    {
      id: 1,
      question: 'What is the minimum order quantity (MOQ)?',
      answer: 'We offer flexible minimum order quantities based on the product range and customization requirements. Sample orders are available, and bulk purchase options can be tailored to your business needs. Contact us for details.'
    },
    {
      id: 2,
      question: 'What is the delivery timeline?',
      answer: 'Standard delivery takes 15-20 days from order confirmation. Custom branding orders may take 25-30 days. Express delivery is available for urgent orders at additional cost. We ship across India with reliable logistics partners.'
    },
    {
      id: 3,
      question: 'Do you provide warranty?',
      answer: 'Yes, we offer 1 year  warranty on all hearing aids.'
    },
    
    {
      id: 4,
      question: 'How does custom branding work?',
      answer: 'Our BYOB (Build Your Own Brand) program helps you create a unique brand identity with custom branding and marketing support.'
    },
    {
      id: 8,
      question: 'What after-sales support is offered?',
      answer: 'Instant Replacement Warranty, Priority Service & Customer Support'
    },
    {
      id: 9,
      question: 'Can I get samples before bulk order?',
      answer: 'Yes, we offer sample orders of 5-10 units per product model. Sample cost is adjustable against bulk order. Shipping charges applicable on samples.'
    },
    {
      id: 10,
      question: 'Do you have distributor exclusivity?',
      answer: 'Yes, we offer exclusive distributorship rights for specific territories based on order commitment and market potential. Contact our team to discuss exclusive partnership opportunities.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <section id="faq" className="faq-section">
        <div className="faq-container">
          
          {/* Section Header */}
          <div className="faq-header">
            <span className="faq-tagline">Got Questions?</span>
            <h2 className="faq-title">
              Frequently Asked <span className="faq-highlight">Questions</span>
            </h2>
            <div className="faq-underline"></div>
            <p className="faq-subtitle">
              Find answers to common questions about our products, services, and partnership opportunities.
            </p>
          </div>

          <div className="faq-wrapper">
            {/* FAQ List */}
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div 
                  key={faq.id} 
                  className={`faq-item ${openIndex === index ? 'active' : ''}`}
                >
                  <div 
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question-left">
                      <span className="faq-question-icon">?</span>
                      <h3>{faq.question}</h3>
                    </div>
                    <div className="faq-question-arrow">
                      {openIndex === index ? '−' : '+'}
                    </div>
                  </div>
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Still Have Questions */}
            <div className="faq-contact-card">
              <div className="faq-contact-icon">💬</div>
              <h3>Still Have Questions?</h3>
              <p>Can't find the answer you're looking for? Please contact our team.</p>
              <div className="faq-contact-buttons">
                <button onClick={openQuoteModal} className="faq-contact-btn primary">
                  Ask Your Question
                  <svg className="faq-btn-icon" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button onClick={handleContactSupport} className="faq-contact-btn secondary">
                  Contact Support
                </button>
              </div>
              <div className="faq-contact-info">
                <div className="faq-contact-item">
                  <span>📞</span>
                  <a href="tel:03323240508">033-23240508</a>
                </div>
                <div className="faq-contact-item">
                  <span>💬</span>
                  <a href="https://wa.me/919748691530">+91 9748691530</a>
                </div>
                <div className="faq-contact-item">
                  <span>✉️</span>
                  <a href="mailto:info@paplhear.com">info@paplhear.com</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </>
  );
};

export default FAQSection;